<template>
  <div class="row mt-4" v-if="retencion.global && retencion.global.total > 0">
    <div class="col-12">
      <div class="card ficha-listado">
        <div class="px-4 pb-4 card-body">

          <div class="mb-3">
            <h6 class="mb-0 panel-section-title">Retención de suscriptores</h6>
            <p class="text-xs opacity-7 mb-0">Porcentaje que sigue activo tras 1, 3 y 6 meses desde que se suscribió</p>
          </div>

          <!-- KPIs globales -->
          <div class="row g-2 mb-4">
            <div class="col-6 col-md-3">
              <div class="ret-kpi">
                <div class="ret-kpi__k">Activos hoy</div>
                <div class="ret-kpi__v" :class="colorPct(retencion.global.pct_activos)">
                  {{ retencion.global.pct_activos }}%
                </div>
                <div class="ret-kpi__sub">{{ retencion.global.activos_hoy }} de {{ retencion.global.total }}</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="ret-kpi">
                <div class="ret-kpi__k">Retención 1 mes (%)</div>
                <div class="ret-kpi__v" :class="colorPct(retencion.global.pct_1m)">
                  {{ retencion.global.pct_1m }}%
                </div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="ret-kpi">
                <div class="ret-kpi__k">Retención 3 meses (%)</div>
                <div class="ret-kpi__v" :class="colorPct(retencion.global.pct_3m)">
                  {{ retencion.global.pct_3m }}%
                </div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="ret-kpi">
                <div class="ret-kpi__k">Permanencia media</div>
                <div class="ret-kpi__v ret-kpi__v--neutral">
                  {{ retencion.global.dias_medio_baja !== null ? retencion.global.dias_medio_baja : '—' }}
                </div>
                <div class="ret-kpi__sub" v-if="retencion.global.dias_medio_baja !== null">días de media</div>
              </div>
            </div>
          </div>

          <!-- Tabla de cohortes -->
          <div v-if="retencion.cohortes && retencion.cohortes.length > 1">
            <p class="text-xs fw-bold text-uppercase opacity-7 mb-2">Supervivencia por mes de entrada</p>
            <div class="table-responsive">
              <table class="table table-sm ret-table">
                <thead>
                  <tr>
                    <th>Mes de entrada</th>
                    <th class="text-center">Total</th>
                    <th class="text-center">1 mes</th>
                    <th class="text-center">3 meses</th>
                    <th class="text-center">6 meses</th>
                    <th class="text-center">Activos hoy</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="r in retencion.cohortes" :key="r.cohort">
                    <td class="ret-cohort">{{ fmtMes(r.cohort) }}</td>
                    <td class="text-center fw-bold">{{ r.total }}</td>
                    <td class="text-center">
                      <span v-if="r.pct_1m !== null" class="ret-badge" :class="colorPct(r.pct_1m)">{{ r.pct_1m }}%</span>
                      <span v-else class="ret-nd">—</span>
                    </td>
                    <td class="text-center">
                      <span v-if="r.pct_3m !== null" class="ret-badge" :class="colorPct(r.pct_3m)">{{ r.pct_3m }}%</span>
                      <span v-else class="ret-nd">—</span>
                    </td>
                    <td class="text-center">
                      <span v-if="r.pct_6m !== null" class="ret-badge" :class="colorPct(r.pct_6m)">{{ r.pct_6m }}%</span>
                      <span v-else class="ret-nd">—</span>
                    </td>
                    <td class="text-center">
                      <span class="ret-badge" :class="colorPct(r.pct_hoy)">{{ r.pct_hoy }}%</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="text-xs opacity-5 mt-1 mb-0">— Todavía no ha pasado suficiente tiempo para medir este período</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
const MESES = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];
function fmtMes(s) {
  if (!s) return s;
  const [y, m] = s.split("-");
  return `${MESES[parseInt(m) - 1]} '${String(y).slice(2)}`;
}

export default {
  name: "PanelTipsterRetencion",
  props: {
    retencion: {
      type: Object,
      default: () => ({ global: null, cohortes: [] }),
    },
  },
  methods: {
    fmtMes,
    colorPct(pct) {
      if (pct === null) return "ret-kpi__v--neutral";
      if (pct >= 70) return "ret-kpi__v--verde";
      if (pct >= 40) return "ret-kpi__v--naranja";
      return "ret-kpi__v--rojo";
    },
  },
};
</script>

<style scoped>
.ret-kpi {
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 12px;
  padding: 12px 14px;
  min-height: 78px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
}
.ret-kpi__k {
  font-size: 0.6875rem; color: var(--q-muted); font-weight: 600;
  text-transform: uppercase; letter-spacing: .4px;
}
.ret-kpi__v         { font-size: 1.375rem; font-weight: 800; line-height: 1.1; }
.ret-kpi__v--verde   { color: var(--q-green); }
.ret-kpi__v--naranja { color: var(--q-amber); }
.ret-kpi__v--rojo    { color: var(--q-red); }
.ret-kpi__v--neutral { color: var(--q-text); }
.ret-kpi__sub { font-size: 0.625rem; color: var(--q-muted); }

/* Tabla */
.ret-table { font-size: 0.75rem; border-collapse: collapse; }
.ret-table th,
.ret-table td { border: none !important; box-shadow: none !important; }
.ret-table thead th {
  font-size: 0.625rem; text-transform: uppercase; color: var(--q-muted);
  font-weight: 600; border-bottom: 1px solid var(--q-border) !important; padding: 4px 8px;
}
.ret-table tbody td { padding: 7px 8px; border-bottom: 1px solid var(--q-border) !important; color: var(--q-text); }
.ret-cohort { font-weight: 700; color: var(--q-text); }

.ret-badge {
  font-size: 0.6875rem; font-weight: 700;
  padding: 2px 8px; border-radius: 20px;
  display: inline-block;
}
.ret-badge.ret-kpi__v--verde   { background: var(--q-green-soft); }
.ret-badge.ret-kpi__v--naranja { background: var(--q-amber-soft); }
.ret-badge.ret-kpi__v--rojo    { background: var(--q-red-soft); }

.ret-nd { color: var(--q-muted); font-size: 0.8125rem; }
</style>
